'use client'

import dynamic from 'next/dynamic'

// Code-split the chat widget (react-markdown, remark-gfm, turnstile) out of the
// shared layout bundle; it is closed by default and not needed for first paint.
const ChatWidget = dynamic(() => import('@/components/ChatWidget'), {
  ssr: false,
})

export default function ChatWidgetLoader() {
  return <ChatWidget />
}
